import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onLearnMoreClick"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { useCallback, useMemo, useState } from 'react';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Flex } from 'foundations-components/components/Flex';
import { MEETING_NOTETAKER_ALERT_DISMISSED } from 'MeetingsLib/constants/localStorage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MeetingNotetakerAlert(_ref) {
  let {
      onLearnMoreClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isDismissedFromLocalStorage = useMemo(() => {
    try {
      const hasDismissedAlert = localStorage.getItem(MEETING_NOTETAKER_ALERT_DISMISSED);
      return hasDismissedAlert === 'true';
    } catch (error) {
      Raven.captureMessage('Error reading meeting-notetaker-alert-dismissed from local storage', {
        extra: error
      });
      return false;
    }
  }, []);
  const [isDismissed, setIsDismissed] = useState(isDismissedFromLocalStorage);
  const handleDismissAlert = useCallback(() => {
    try {
      setIsDismissed(true);
      localStorage.setItem(MEETING_NOTETAKER_ALERT_DISMISSED, 'true');
    } catch (error) {
      Raven.captureMessage('Error setting meeting-notetaker-alert-dismissed to local storage', {
        extra: error
      });
    }
  }, []);
  if (isDismissed) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    children: /*#__PURE__*/_jsx(Alert, Object.assign({
      closeable: true,
      inlineSize: "100%",
      use: "inline",
      type: "tip",
      padding: "300",
      onClose: handleDismissAlert,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "breeze.meetingNotetaker.alert.title"
      })
    }, props, {
      children: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "breeze.meetingNotetaker.alert.description"
        }), /*#__PURE__*/_jsx(Button, {
          use: "tertiary-light",
          size: "xs",
          onClick: onLearnMoreClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "buttons.learnMore"
          })
        })]
      })
    }))
  });
}